// src/components/messages/SharedProductPreview.js
import React from 'react';
import './SharedProductPreview.css';
import { useNavigate } from 'react-router-dom';

import placeholderLogo from '../../assets/placeholder-profile.png';

function SharedProductPreview({ product, onOpenProduct }) {
  const navigate = useNavigate();
  if (!product) return null;

  const {
    _id,
    name,
    description,
    price,
    usdPrice,
    media = [],
    mediaType,
    username,
    storeName,
    businessUsername,
    businessLogo,
  } = product;

  // Resolve product id
  const productId =
    _id ||
    product.id ||
    product.productId ||
    (product.product && (product.product._id || product.product.id)) ||
    null;

  const mediaUrl = Array.isArray(media) && media[0] ? media[0] : null;

  const goToProduct = () => {
    if (typeof onOpenProduct === 'function') {
      onOpenProduct();
      return;
    }

    if (productId) {
      navigate(`/product/${productId}`);
      return;
    }

    if (businessUsername || username) {
      navigate(`/marketplace/store/${businessUsername || username}`);
    }
  };

  const renderPrice = () => {
    if (typeof price === 'number') return `${price.toFixed(2)} Pi`;
    if (typeof price === 'string' && price.trim()) return price;
    if (typeof usdPrice === 'number') return `$${usdPrice.toFixed(2)} USD`;
    return '—';
  };

  const businessName = storeName || 'Store';
  const businessHandle = businessUsername || username || '';
  const logoSrc = businessLogo || placeholderLogo;

  return (
    <div className="shared-product-preview" onClick={goToProduct}>
      
      {/* ===== Business Header ===== */}
      <div className="shared-product-header">
        <img
          src={logoSrc}
          alt="store logo"
          className="shared-product-bizlogo"
          onError={(e) => (e.currentTarget.src = placeholderLogo)}
        />

        <div className="shared-product-info">
          <div className="shared-product-owner">{businessName}</div>
          {businessHandle && (
            <div className="shared-product-username">
              @{businessHandle}
            </div>
          )}
        </div>
      </div>

      {/* ===== Body ===== */}
      <div className="shared-product-body">
        {mediaUrl ? (
          mediaType === 'video' ? (
            <video
              className="shared-product-media"
              src={mediaUrl}
              muted
              playsInline
              preload="metadata"
            />
          ) : (
            <img
              src={mediaUrl}
              alt="product"
              className="shared-product-media"
            />
          )
        ) : (
          <div className="shared-product-media shared-product-media--placeholder">
            No media
          </div>
        )}

        <div className="shared-product-meta">
          <div className="shared-product-name">
            {name || 'Untitled product'}
          </div>

          <div className="shared-product-price-row">
            <span className="shared-product-price">
              {renderPrice()}
            </span>
          </div>

          {description && (
            <div className="shared-product-desc">
              {description}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SharedProductPreview;
